import { render, staticRenderFns } from "./moduleTwo.vue?vue&type=template&id=a923b1ae&scoped=true&"
import script from "./moduleTwo.vue?vue&type=script&lang=js&"
export * from "./moduleTwo.vue?vue&type=script&lang=js&"
import style0 from "./moduleTwo.vue?vue&type=style&index=0&id=a923b1ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a923b1ae",
  null
  
)

export default component.exports